import UnableToFinish from "components/card/unable-to-finish/UnableToFinish";
import ApplicationContainer from "components/application-container/ApplicationContainer";
import { useContactInformation } from "hooks/useContactInformation";
import { useMarkApplicationSubmitted } from "hooks";

const UnableToFinishPage = () => {
    const { contactData } = useContactInformation();

    useMarkApplicationSubmitted();

    return (
        <>
            <title>Unable to Finish | AAA Life</title>
            <ApplicationContainer useTitle={false} data-testid="unable-to-finish-page">
                <UnableToFinish referenceNumber={contactData?.policyNumber ?? ""} />
            </ApplicationContainer>
        </>
    );
};

export default UnableToFinishPage;
